import type { ApiCallOptions } from './client';

export interface CommandOptions extends ApiCallOptions {
  idempotencyKey: string;
}

export function commandOptions({ idempotencyKey, signal }: CommandOptions) {
  return { signal, headers: { 'Idempotency-Key': idempotencyKey } };
}
